/* tslint:disable */
/* eslint-disable */

/**
 * OrderCreated is a display-only status: an Approved quote whose linked order request
 * reached OrderRequestState.OrderCreated (or beyond). It has no backing Quote.Status value.
 */
export enum QuoteStatusEnum {
  Draft = 'Draft',
  WaitingForPreApproval = 'WaitingForPreApproval',
  PreApproved = 'PreApproved',
  PreRejected = 'PreRejected',
  Approved = 'Approved',
  Rejected = 'Rejected',
  ApprovedOverBudget = 'ApprovedOverBudget',
  OverBudgetAccepted = 'OverBudgetAccepted',
  OverBudgetRejected = 'OverBudgetRejected',
  OrderCreated = 'OrderCreated',
}
